import jsPDF from "jspdf";
import { AcuminProBold, AcuminProItalic, AcuminProRegular } from "./acuminFontData";

/**
 * Register Acumin Pro fonts with jsPDF using embedded base64 data.
 * This ensures fonts are available without network requests.
 * 
 * Standard procedure for custom fonts in jsPDF:
 * 1. Load base64 content
 * 2. addFileToVFS
 * 3. addFont
 * 4. setFont
 */
export async function registerAcuminProFonts(doc: jsPDF): Promise<void> {
  try {
    console.log('🔄 Registering Acumin Pro fonts from embedded data...');
    // Bold
    if (AcuminProBold) {
        doc.addFileToVFS('AcuminPro-Bold.ttf', AcuminProBold);
        doc.addFont('AcuminPro-Bold.ttf', 'AcuminPro', 'bold');
        console.log('✓ AcuminPro-Bold registered');
    } else {
        console.warn('⚠️ AcuminProBold data missing');
    }

    // Italic
    if (AcuminProItalic) {
        doc.addFileToVFS('AcuminPro-Italic.ttf', AcuminProItalic);
        doc.addFont('AcuminPro-Italic.ttf', 'AcuminPro', 'italic');
        console.log('✓ AcuminPro-Italic registered');
    } else {
        console.warn('⚠️ AcuminProItalic data missing');
    }

    // Regular
    if (AcuminProRegular) {
        doc.addFileToVFS('AcuminPro-Regular.ttf', AcuminProRegular);
        doc.addFont('AcuminPro-Regular.ttf', 'AcuminPro', 'normal');
        console.log('✓ AcuminPro-Regular registered');
    } else {
        console.warn('⚠️ AcuminProRegular data missing');
    }

    // Set default
    try {
        doc.setFont('AcuminPro', 'normal');
        console.log('✓ Default font set to AcuminPro');
    } catch (e) {
        console.warn("Could not set default font to AcuminPro");
    }

    console.log('✅ Acumin Pro fonts registered successfully');
  } catch (error) {
    
    console.error('❌ Failed to register Acumin Pro fonts:', error);
  }
}

export function areAcuminProFontsAvailable(): boolean {
    return !!(AcuminProBold && AcuminProItalic && AcuminProRegular);
}
